import { setIsEdited } from "./store";
import { mutate } from "swr";

export const handleAddSlot = (
    day: string,
    setOpeningHours: Function,
    isAllWeek: boolean,
    openingHours: any,
    setIsAllWeek: Function
) => {
    let newData: any = {};
    setOpeningHours((prev: any) => {
        newData = {
            ...prev[day],
            slots: [...prev[day].slots, { from: "", to: "" }],
        };
        return {
            ...prev,
            [day]: newData,
        };
    });
    if (day === "7" && isAllWeek === true) {
        setAllWeek(openingHours, newData, setOpeningHours);
    } else if (day !== "7" && isAllWeek === true) {
        setIsAllWeek(false);
    }
    setIsEdited(true);
};

export const handleRemoveSlot = (
    day: string,
    index: number,
    setOpeningHours: Function,
    isAllWeek: boolean,
    openingHours: any,
    setIsAllWeek: Function,
    setErrors?: Function
) => {
    let newData: any = {};
    setOpeningHours((prev: any) => {
        newData = {
            ...prev[day],
            slots: prev[day].slots.filter((_: any, i: number) => i !== index),
        };
        return {
            ...prev,
            [day]: newData,
        };
    });

    // Clear errors for the deleted slot and reindex remaining errors
    if (setErrors) {
        setErrors((prev: any) => {
            const newErrors = { ...prev };

            if (newErrors[day]) {
                const dayErrors = { ...newErrors[day] };
                const reindexedErrors: any = {};

                // Remove the error for the deleted slot and reindex
                Object.keys(dayErrors).forEach((slotIndex) => {
                    const idx = parseInt(slotIndex);
                    if (idx < index) {
                        // Keep errors before deleted slot with same index
                        reindexedErrors[idx] = dayErrors[idx];
                    } else if (idx > index) {
                        // Shift down errors after deleted slot
                        reindexedErrors[idx - 1] = dayErrors[idx];
                    }
                    // idx === index is the deleted slot, so we skip it
                });

                if (Object.keys(reindexedErrors).length === 0) {
                    delete newErrors[day];
                } else {
                    newErrors[day] = reindexedErrors;
                }
            }

            // If all week is active and we're removing from day 7, clear errors for all days
            if (day === "7" && isAllWeek === true) {
                Object.keys(openingHours).forEach((dayKey) => {
                    if (newErrors[dayKey]) {
                        const dayErrors = { ...newErrors[dayKey] };
                        const reindexedErrors: any = {};

                        Object.keys(dayErrors).forEach((slotIndex) => {
                            const idx = parseInt(slotIndex);
                            if (idx < index) {
                                reindexedErrors[idx] = dayErrors[idx];
                            } else if (idx > index) {
                                reindexedErrors[idx - 1] = dayErrors[idx];
                            }
                        });

                        if (Object.keys(reindexedErrors).length === 0) {
                            delete newErrors[dayKey];
                        } else {
                            newErrors[dayKey] = reindexedErrors;
                        }
                    }
                });
            }

            return newErrors;
        });
    }

    if (day === "7" && isAllWeek === true) {
        setAllWeek(openingHours, newData, setOpeningHours);
    } else if (day !== "7" && isAllWeek === true) {
        setIsAllWeek(false);
    }
    setIsEdited(true);
};

export const handleChangeSlot = (
    day: string,
    index: number,
    field: "from" | "to",
    value: string,
    setOpeningHours: Function,
    openingHours: any,
    isAllWeek: any,
    setIsAllWeek: Function,
    setErrors: Function
) => {
    const updatedSlots = [...openingHours[day].slots];
    updatedSlots[index][field] = value;

    // Clear errors for this specific field when user types
    setErrors((prev: any) => {
        const newErrors = { ...prev };

        // Clear error for the specific field (from or to)
        if (newErrors[day] && newErrors[day][index]) {
            const slotErrors = { ...newErrors[day][index] };
            delete slotErrors[field]; // Clear only the field being edited

            if (Object.keys(slotErrors).length === 0) {
                // No more errors for this slot, remove it
                const dayErrors = { ...newErrors[day] };
                delete dayErrors[index];
                if (Object.keys(dayErrors).length === 0) {
                    delete newErrors[day];
                } else {
                    newErrors[day] = dayErrors;
                }
            } else {
                // Still has errors for other fields
                newErrors[day] = { ...newErrors[day], [index]: slotErrors };
            }
        }

        // If all week is active and we're editing day 7, clear errors for all days
        if (day === "7" && isAllWeek === true) {
            Object.keys(openingHours).forEach((dayKey) => {
                if (newErrors[dayKey] && newErrors[dayKey][index]) {
                    const slotErrors = { ...newErrors[dayKey][index] };
                    delete slotErrors[field];

                    if (Object.keys(slotErrors).length === 0) {
                        const dayErrors = { ...newErrors[dayKey] };
                        delete dayErrors[index];
                        if (Object.keys(dayErrors).length === 0) {
                            delete newErrors[dayKey];
                        } else {
                            newErrors[dayKey] = dayErrors;
                        }
                    } else {
                        newErrors[dayKey] = {
                            ...newErrors[dayKey],
                            [index]: slotErrors,
                        };
                    }
                }
            });
        }

        return newErrors;
    });

    let newData = { ...openingHours[day], slots: updatedSlots };
    setOpeningHours((prev: any) => ({ ...prev, [day]: newData }));

    if (day === "7" && isAllWeek === true) {
        setAllWeek(openingHours, newData, setOpeningHours);
    } else if (day !== "7" && isAllWeek === true) {
        setIsAllWeek(false);
    }
    setIsEdited(true);
};

export const handleChangeState = (
    day: string,
    checked: boolean,
    setOpeningHours: Function,
    openingHours: any,
    isAllWeek: any,
    setIsAllWeek: Function
) => {
    let newData = { ...openingHours[day], open: checked };

    setOpeningHours((prev: any) => ({
        ...prev,
        [day]: newData,
    }));

    if (day === "7" && isAllWeek === true) {
        setAllWeek(openingHours, newData, setOpeningHours);
    } else if (day !== "7" && isAllWeek === true) {
        setIsAllWeek(false);
    }
    setIsEdited(true);
};
export const setAllWeek = (
    openingHours: any,
    day: any,
    setOpeningHours: Function
) => {
    let newOpeningHours: any = {};
    Object.keys(openingHours).forEach(
        (key: any) => (newOpeningHours[key] = structuredClone(day))
    );
    setOpeningHours(newOpeningHours);
    setIsEdited(true);
};

export function hasOverlaps(openingHours: any): boolean {
    for (const dayKey in openingHours) {
        const slots = openingHours[dayKey].slots;
        // Sort by start time
        const sorted = [...slots].sort((a, b) => a.from.localeCompare(b.from));
        for (let i = 0; i < sorted.length - 1; i++) {
            if (sorted[i].to > sorted[i + 1].from) {
                return true; // overlap found
            }
        }
    }
    return false;
}

export function isOverlapping(currentIndex: number, slots: any[]) {
    const current = slots[currentIndex];
    const currentFrom = current.from;
    const currentTo = current.to;

    // If current slot has empty times, no overlap
    if (!currentFrom || !currentTo) return false;

    return slots.some((slot, i) => {
        if (i === currentIndex) return false; // skip self
        // Skip slots with empty times
        if (!slot.from || !slot.to) return false;
        return currentFrom < slot.to && currentTo > slot.from;
    });
}

export async function RedisPublishFoodCourt(
    shopId: any,
    t: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let redisApiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/foodCourt/redis`;
    try {
        const data: any = await fetchGlobal<any>(redisApiUrl, {
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                shopId: shopId,
            }),
            method: "POST",
        });
        mutate(redisApiUrl, data);
        if (data.error) {
            throw Error("Error while saving selection!");
        }
    } catch (e: any) {
        console.log(`${t("There's an error")}!`);
    }
}
